export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'estimation.delete_formula',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:estimation:formula:export',
    },
  },
}